import {useNavigate} from "react-router-dom";

const usePatients = () => {

    let navigate = useNavigate();

    const actions = {
        add: () => false,
        edit: (id) => navigate(`/pacientes/${id}/editar-paciente`),
        delete: true,
    };

    return {
        actions
    }
};

export default usePatients;
